import axios from '../axios/axios';
import {
  OTHER_GENERAL_QUESTIONS_DATA_REQUEST,
  OTHER_GENERAL_QUESTIONS_DATA_SUCCESS,
  OTHER_GENERAL_QUESTIONS_DATA_FAIL,
} from '../constants/otherGeneralQuestionsConstants';

export const otherGeneralQuestionsAction = () => async (dispatch) => {
  try {
    dispatch({ type: OTHER_GENERAL_QUESTIONS_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s13',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: OTHER_GENERAL_QUESTIONS_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: OTHER_GENERAL_QUESTIONS_DATA_FAIL,
      payload: error,
    });
  }
};
